var map = {
	"./bg_grid_white.png": "dfa0",
	"./contract@2x.png": "934f",
	"./f(x)DexHomepage@2x.jpg": "a826",
	"./funding@2x.png": "fc79",
	"./fxWalletConnect@2x.jpg": "87ab",
	"./governance@2x.png": "3d9c",
	"./guarantee@2x.png": "fcec",
	"./img_actbar@2x.png": "dbd2e",
	"./img_actbar_mini@2x.png": "1c1a",
	"./liquidation@2x.png": "d08d",
	"./match@2x.png": "ef50",
	"./order@2x.png": "2c05",
	"./orderbook@2x.png": "5a57",
	"./price@2x.png": "fbae",
	"./rate@2x.png": "da84",
	"./settlement@2x.png": "6678",
	"./var_01_backlight.svg": "36c7",
	"./var_01_mobile.png": "f4e3c",
	"./var_01_web.png": "286c",
	"./var_02_asset.png": "9182",
	"./var_02_base1.png": "3737",
	"./var_02_base1_backlight.svg": "0a52",
	"./var_02_base2.png": "658d",
	"./var_02_base3.png": "1e16",
	"./var_02_coin.png": "10d2",
	"./var_02_control.png": "e5c6",
	"./var_02_dec.png": "4530",
	"./var_02_dec_move.png": "98ef",
	"./var_02_gas.png": "b1a8",
	"./var_02_gas_move.png": "48dc",
	"./var_02_line_left.png": "3230",
	"./var_02_line_right.png": "9ddc",
	"./var_02_safe.png": "117c",
	"./var_02_safe_move.png": "8c52",
	"./var_02_slippage.png": "9da3",
	"./var_02_slippage_ic_price1.png": "83b8",
	"./var_02_slippage_ic_price2.png": "be65",
	"./var_02_slippage_ic_time1.png": "b524",
	"./var_02_slippage_ic_time2.png": "fa53",
	"./var_02_xrobot1.png": "0282",
	"./var_02_xrobot1_backlight.svg": "8e5f",
	"./var_02_xrobot2.png": "e5e5",
	"./var_02_xrobot2_backlight.svg": "ad4c",
	"./var_03_base.png": "09e4",
	"./var_03_circle1.svg": "66ef",
	"./var_03_circle2.svg": "40fb",
	"./var_03_frame.png": "f1dd",
	"./var_03_step1@2x.jpg": "5dba",
	"./var_03_step2@2x.jpg": "41f0",
	"./var_03_step3@2x.jpg": "b175",
	"./var_04_bg.png": "1dc1",
	"./var_04_cursor.png": "a54a",
	"./var_icon_backlight.svg": "57ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "095e";